import { useDispatch, useSelector } from 'react-redux';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { setThemeState } from '../../../redux/slice/settingsSlice';

import SettingsStyledComponents from './styles';

const { StyledSetListItem, StyledSetTpg } = SettingsStyledComponents;

export default function ThemeModeSelector() {
  const { language, themeState } = useSelector((state) => state.settings);
  const dispatch = useDispatch();

  function handleChangeThemeState(e) {
    dispatch(setThemeState(e.target.value));
  }

  return (
    <StyledSetListItem>
      <StyledSetTpg>{language.settings.theme}</StyledSetTpg>
      <RadioGroup row name="theme-mode" value={themeState} onChange={handleChangeThemeState}>
        <FormControlLabel value="light" control={<Radio />} label={language.settings.light} />
        <FormControlLabel value="dark" control={<Radio />} label={language.settings.dark} />
        <FormControlLabel value="system" control={<Radio />} label={language.settings.system} />
      </RadioGroup>
    </StyledSetListItem>
  );
}
